import { display } from '../common';
import { Project } from '~/types/project';
import { DeploymentTypes } from '~/constants/deployment-type';

export default function customer(project: Project) {
  return {
    name: display(project?.deploymentType === DeploymentTypes.COMMUNITY_SOLAR ? 'Community Solar' : project.customerName),
  };
}